import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-what-is-the-difference-between-tires',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './what-is-the-difference-between-tires.component.html',
  styleUrl: './what-is-the-difference-between-tires.component.css'
})
export class WhatIsTheDifferenceBetweenTiresComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.whats_difference;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
